"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPersianLeap = void 0;
function isPersianLeap(year) {
    var decimal = 0.24219858156;
    var constant = 2346;
    var calculation = (year + constant) * decimal;
    var result = calculation - Math.floor(calculation);
    if (result < decimal) {
        return true;
    }
    else {
        return false;
    }
}
exports.isPersianLeap = isPersianLeap;
